// Storage service for managing pair token in localStorage

const STORAGE_KEYS = {
  PAIR_TOKEN: 'vr_pair_token',
  TOKEN_TIMESTAMP: 'vr_token_timestamp',
  USER_ID: 'vr_user_id'
};

const TOKEN_VALIDITY_DAYS = 90;

export const storageService = {
  /**
   * Save pair token to localStorage
   */
  savePairToken(token, userId = null) {
    try {
      localStorage.setItem(STORAGE_KEYS.PAIR_TOKEN, token);
      localStorage.setItem(STORAGE_KEYS.TOKEN_TIMESTAMP, Date.now().toString());
      if (userId) {
        localStorage.setItem(STORAGE_KEYS.USER_ID, userId);
      }
      return true;
    } catch (error) {
      console.error('Failed to save pair token:', error);
      return false;
    }
  },

  /**
   * Get pair token from localStorage
   */
  getPairToken() {
    try {
      return localStorage.getItem(STORAGE_KEYS.PAIR_TOKEN);
    } catch (error) {
      console.error('Failed to get pair token:', error);
      return null;
    }
  },

  /**
   * Check if token exists
   */
  hasPairToken() {
    return !!this.getPairToken();
  },

  /**
   * Check if token is expired (90 days)
   */
  isTokenExpired() {
    try {
      const timestamp = localStorage.getItem(STORAGE_KEYS.TOKEN_TIMESTAMP);
      if (!timestamp) return true;

      const ageMs = Date.now() - parseInt(timestamp);
      const ageDays = ageMs / (1000 * 60 * 60 * 24);

      return ageDays >= TOKEN_VALIDITY_DAYS;
    } catch (error) {
      console.error('Failed to check token expiry:', error);
      return true;
    }
  },

  /**
   * Check if token is valid (exists and not expired)
   */
  isTokenValid() {
    return this.hasPairToken() && !this.isTokenExpired();
  },

  /**
   * Clear all pairing data
   */
  clearPairingData() {
    try {
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
      return true;
    } catch (error) {
      console.error('Failed to clear pairing data:', error);
      return false;
    }
  },

  /**
   * Get days until token expires
   */
  getDaysUntilExpiry() {
    try {
      const timestamp = localStorage.getItem(STORAGE_KEYS.TOKEN_TIMESTAMP);
      if (!timestamp) return 0;

      const ageMs = Date.now() - parseInt(timestamp);
      const ageDays = ageMs / (1000 * 60 * 60 * 24);
      const daysLeft = TOKEN_VALIDITY_DAYS - ageDays;

      return Math.max(0, Math.floor(daysLeft));
    } catch (error) {
      return 0;
    }
  }
};
